
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import { SortFilter } from './sortFilter'

// types

export default defineComponent({
  name: 'IssueOccurrenceSection',
  data() {
    return {
      searchIssue: '' as string | (string | null)[],
      selectedFilter: this.$route.query['sort'] as string | (string | null)[],
      sortFilters: [
        { label: 'First Seen', icon: 'first-seen', name: 'first-seen', isActive: false },
        { label: 'Last Seen', icon: 'last-seen', name: 'last-seen', isActive: true }
      ] as SortFilter[]
    }
  },

  mounted() {
    this.selectedFilter = this.$route.query['sort']
    this.searchIssue = this.$route.query['q']
  },

  computed: {
    ...mapState('issue/detail', {
      issue: (state: any) => state.issue
    }),
    sortApplied(): boolean {
      return this.$route.query['sort'] ? true : false
    }
  },

  methods: {
    clearSearch() {
      this.searchIssue = ''
      this.$emit('filter-removed', 'q')
    },

    clearSort() {
      this.$emit('filter-removed', 'sort')
    },

    sortIssues(name: string) {
      this.selectedFilter = name
      this.$emit('filters-updated', {
        sort: name
      })
    },
    searchIssueChildren() {
      this.$emit('filters-updated', {
        q: this.searchIssue ? this.searchIssue : null
      })
    }
  }
})
